module.exports = __webpack_public_path__ + "img/gold.back.497ec9cd.png";